// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"VariableTasteSection_itemsContainer__dpVEH","itemContainer":"VariableTasteSection_itemContainer__mXPnm"};